import { fromJS, Record } from 'immutable';
import { TaskItemContent } from './task-item-content.model';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { TaskItemStateEnum } from '../../home-data.data';

export const TASK_ITEM_SCHEMA = Object.freeze({
  ID: '',
  STATE: TaskItemStateEnum,
  POSITION: 1,
  TYPE: '',
  EXPIRY_DATE: '',
  CONTENT: TaskItemContent,
});
export const RECORD = generateSchema(TASK_ITEM_SCHEMA);
export const KEYS: any = generateKeys(TASK_ITEM_SCHEMA);

export class TaskItem extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.CONTENT,
        value: new TaskItemContent(this.content),
      },
    ]);

    return selfModel as TaskItem;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get state(): TaskItemStateEnum {
    return this.get(KEYS.STATE);
  }

  get position(): number {
    return this.get(KEYS.POSITION);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get expiryDate(): string {
    return this.get(KEYS.EXPIRY_DATE);
  }

  get content(): TaskItemContent {
    return this.get(KEYS.CONTENT);
  }
}
